const routes = [
  {
    path: "/empresa",
    name: "Empresas",
    component: () => import("@/views/forms/Empresa.vue"),
  },
  {
    path: "/usuario",
    name: "Usuarios",
    component: () => import("@/views/forms/Usuario.vue"),
  },
  {
    path: "/persona-usuario",
    name: "Creación de usuarios",
    component: () => import("@/views/forms/PersonaUsuarioReg.vue"),
  },
];

export { routes };
